<template>
  <div>
    <exit-intent
      storage-id="video-page-exit-intent"
      :hide-for-user="false"
      @fire="fireExitIntent()"
    />

    <Dialog v-model:open="isDialogOpen">
      <DialogScrollContent class="tw:max-w-xl tw:bg-[rgba(var(--video-frame-color))]">
        <VisuallyHidden>
          <DialogTitle>But Wait!</DialogTitle>
        </VisuallyHidden>
        <div class="tw:px-6 tw:pt-6 tw:text-center">
          <div v-if="profile.team_logo" class="tw:w-[300px] tw:my-[20px] tw:mx-auto">
            <img class="tw:w-full" :src="profile.team_logo" alt="">
          </div>
          <CallToActions
            button-class-name="w-100"
            :call-to-actions="callToActions"
            :current-video="currentVideo"
            :description-color="titleColor"
            @click-call-to-action="clickCta"
          />
          <ProfileSignature v-if="shouldShowProfileSignature" :title-color="titleColor" :profile="profile" />
        </div>
      </DialogScrollContent>
    </Dialog>
  </div>
</template>

<script>
import { VisuallyHidden } from 'reka-ui'
import {
  Dialog,
  DialogScrollContent,
  DialogTitle,
} from '@/shadcn/components/ui/dialog'
import CallToActions from './call-to-actions.vue'
import ProfileSignature from './profile-signature.vue'

export default {
  name: 'ExitIntentModal',
  components: {
    DialogTitle,
    VisuallyHidden,
    DialogScrollContent,
    CallToActions,
    ProfileSignature,
    Dialog,
  },
  props: {
    callToActions: {
      type: Array,
      required: true,
    },
    currentVideo: {
      required: true,
    },
    profile: {
      required: true,
    },
    shouldShowProfileSignature: {
      type: Boolean,
      required: true,
    },
    shouldShowPromo: {
      type: Boolean,
      required: true,
    },
    titleColor: {
      type: String,
      required: true,
    },
  },
  emits: ['click-call-to-action'],
  data() {
    return {
      isDialogOpen: false,
    }
  },
  computed: {
    hasVisibleCtaButtons() {
      return this.callToActions.filter((action) => {
        return action.show_button && !action.mobile_only
      }).length > 0
    },
  },
  methods: {
    fireExitIntent() {
      if (this.shouldShowPromo) {
        if (Spark.state.user) {
          return
        }

        this.showPromo()
      }
      else {
        if (this.hasVisibleCtaButtons) {
          this.isDialogOpen = true
        }
      }
    },
    showPromo() {
      window.SwalConfirm.fire({
        imageUrl: this.constants.GLOBAL.DUBB_ICON_URL,
        imageWidth: 80,
        imageHeight: 80,
        title: 'Ready to close more deals?',
        text: 'Record, send, and track personal videos — free to start.',
        confirmButtonText: 'I\'M IN!',
        cancelButtonText: 'No Thanks',
      }).then((res) => {
        if (res.value) {
          location.href = this.router('web.welcome', {
            utm_source: 'VideoLP',
            utm_medium: 'lp',
            utm_campaign: 'ExitModal',
          })
        }
      })
    },
    clickCta(action) {
      this.isDialogOpen = false
      this.$emit('click-call-to-action', action)
    },
  },
}
</script>
